import CatBoarding from './CatBoarding';

export default CatBoarding;
